let Hooks = {}
import {loadScript} from "@paypal/paypal-js";

Hooks.HeaderActions = {
    mounted() {
        this.handleEvent("set-country", function (data) {
            document.cookie = 'country=' + data.country + '; expires=Sun,1 Jan 9999 00:00:00 UTC; path=/; SameSite=Lax'
        });
    }
}

Hooks.Cart = {
    mounted() {
        this.el.addEventListener('cart:enter-tax-number', (e) => {
            let result = prompt("Please enter EU VAT number");
            if (result !== null) {
                this.pushEvent("submit-tax-number", {tax_number: result});
            }
        });
    }
}

Hooks.Billing = {
    mounted() {
        this.el.addEventListener('billing:enter-tax-number', (e) => {
            let result = prompt("Please enter EU VAT number");
            if (result !== null) {
                this.pushEvent("submit-tax-number", {tax_number: result});
            }
        });
    }
}

Hooks.Pay = {
    mounted() {
      this.load();
      // Not inline on* attributes: the payment page's script policy blocks those.
      this.el.addEventListener("submit", (event) => {
        if (event.target.id === "staxpay-form") {
          // LiveView's window listener would otherwise submit a phx-change form natively.
          event.preventDefault();
          event.stopPropagation();
        }
        if (event.target.id === "pay-form") window.liveSocket.disconnect();
      });
      window.addEventListener("shop:pay_via_payfast", (event) => {
          this.pushEvent("pay_via_payfast", {})
      });
      window.addEventListener("shop:pay_via_paypal", (event) => {
          this.pushEvent("pay_via_paypal", {})
      });
      window.addEventListener("shop:pay_via_eft", (event) => {
          this.pushEvent("pay_via_eft", {})
      });
      window.addEventListener("shop:pay_via_zelle", (event) => {
          this.pushEvent("pay_via_zelle", {})
      });
      window.addEventListener("shop:pay_via_staxpay", (event) => {
          this.pushEvent("pay_via_staxpay", {})
      });
    },
    updated() {
      this.load();
    },
    load() {
      const paymentMethod = this.el.dataset.paymentMethod;
      switch (paymentMethod) {
        case "staxpay": this.loadStaxpay(); break;
        case "paypal": this.loadPaypal(); break;
      }
    },
    loadStaxpay(data) {
      if (this.loadedStax) return;
      this.loadedStax = true;
      const hook = this;
      var style = 'margin: 0; padding: 0; outline: none; border: none; height: 100%; width: 100%;';

      var data = document.getElementById("staxpay-data").dataset;

      // staxJs.pay() captures a real charge on every call. Reuse one
      // idempotency_id per order so a double-click, network retry, or
      // page reload returns the original transaction instead of charging
      // the card again. Rotated on failure (a corrected-card retry sends
      // different params, which Stax rejects against a reused key).
      const idemKey = `staxpay_idem_${data.orderId}`;
      const newIdempotencyId = () =>
        (window.crypto && crypto.randomUUID)
          ? crypto.randomUUID()
          : `${data.orderId}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      if (!sessionStorage.getItem(idemKey)) {
        sessionStorage.setItem(idemKey, newIdempotencyId());
      }
      var staxJs = new StaxJs(data.websiteToken, {
        number: {
          id: 'card-number',     // the html id of the div you want to contain the credit card number field
          placeholder: '0000 0000 0000 0000',    // the placeholder the field should contain
          style: style + 'font-size: 20px; font-weight: bold;',
          type: 'text',    // the input type (optional)
          format: 'prettyFormat'    // the formatting of the CC number (prettyFormat || plainFormat || maskedFormat)
        },
        cvv: {
          id: 'card-cvv',    // the html id of the div you want to contain the cvv field
          placeholder: 'CVV',    // the placeholder the field should contain
          style: style + 'font-size: 14px;',
          type: 'text'    // the input type (optional)
        }
      });

      staxJs.showCardForm().then((handler) => {
        // for quick testing, you can set a test number and test cvv here
        // handler.setTestPan("4111111111111111");
        // handler.setTestCvv("123");
      })
      .catch((err) => {
        console.log("there was an error loading the form: ", err);
      });

      staxJs.on("card_form_complete", (message) => {
        hook.pushEvent("staxpay_secret_validate", message);
      });

      staxJs.on("card_form_incomplete", (message) => {
        hook.pushEvent("staxpay_secret_validate", message);
      });

      document.querySelector('#paybutton').onclick = () => {
        // Guard against a second charge from a double-click or repeat
        // click while pay() is still in flight.
        if (hook.staxPaying) return;
        hook.staxPaying = true;

        let data = document.getElementById("staxpay-data").dataset;
        let form = document.getElementById("staxpay-form");
        let payBtn = document.querySelector('#paybutton');
        payBtn.disabled = true;

        let msgEl = document.getElementById("staxpay-message");
        msgEl.classList.add("forward")
        msgEl.classList.add("is-rotating")
        msgEl.innerText = data.processingMessage;

        let details = {
          method: 'card',
          currency: data.currency,
          total: data.amount,
          company: '',
          month: form.querySelector('input[name=exp-month]').value,
          year: form.querySelector('input[name=exp-year]').value,
          firstname: data.firstName,
          lastname: data.lastName,
          email: data.email,
          phone: form.querySelector('input[name=phone]').value,
          address_1: data.addressStreetFirst,
          address_2: data.addressStreetSecond || "",
          address_city: data.addressCity,
          address_state: data.addressProvinceCode,
          address_zip: data.addressCode,
          address_country: data.addressCountryCode,
          meta: { reference: data.orderId },
          idempotency_id: sessionStorage.getItem(idemKey),
          match_customer: true,
          send_receipt: false
        }

        staxJs.pay(details).then((result) => {
          msgEl.classList.add("forward")
          msgEl.classList.add("is-rotating")
          msgEl.innerText = data.verifyingMessage;
          sessionStorage.removeItem(idemKey);
          hook.pushEvent("staxpay_pay_success", result);
        })
        .catch(err => {
          // Real failure: let the user correct details and retry. A
          // corrected retry sends different params, so rotate the key.
          sessionStorage.setItem(idemKey, newIdempotencyId());
          hook.staxPaying = false;
          payBtn.disabled = false;
          hook.pushEvent("staxpay_pay_failure", err);
        })
      }
    },
    loadPaypal(data) {
        if (this.loadedPaypal) return;
        this.loadedPaypal = true;
        const buttons = document.getElementById("paypal-buttons")
        const hook = this;
        if (!buttons.dataset.loaded) {

            loadScript({
                "client-id": buttons.dataset.clientId,
                "enable-funding": "card,credit,venmo",
                "disable-funding": "paylater",
                "data-csp-nonce": document.querySelector("script[nonce]").nonce
            })
                .then((paypal) => {
                    paypal.Buttons({
                        createOrder: function (data, actions) {
                            // Set up the transaction
                            return actions.order.create({
                                payer: {
                                    email_address: buttons.dataset.email,
                                    name: {
                                        given_name: buttons.dataset.firstName,
                                        surname: buttons.dataset.lastName,
                                    }
                                },
                                application_context: {
                                    shipping_preference: "NO_SHIPPING"
                                },
                                purchase_units: [{
                                    amount: {
                                        currency_code: buttons.dataset.currency,
                                        value: buttons.dataset.amount
                                    },
                                    invoice_id: buttons.dataset.invoiceId
                                }]
                            });
                        },
                        onApprove: function (data, actions) {
                            return actions.order.capture().then(function (details) {
                                hook.pushEvent("paypal_pay_success", data)
                            });
                        }
                    }).render('#paypal-buttons');
                })
                .catch((err) => {
                    console.error("Failed to load the PayPal JS SDK script", err);
                });
            buttons.dataset.loaded = true
        }
    }
}
export {Hooks}
